import { ExperimentLiftBadge } from '../../detail/experiment-lift-badge';

interface KpiBulletProps {
  label: string;
  primary: string;
  /** Pre-formatted lift string (e.g. `+6.1%`, `-2.3%`, `+$9.30`). Direction is inferred from the leading sign. */
  lift?: string | undefined;
}

/** Bullet-style metric line used in the Details Performance summary — label on left, value + colored lift badge on right. */
export function KpiBullet({ label, primary, lift }: KpiBulletProps) {
  return (
    <div className="flex items-center justify-between gap-3 text-xs">
      <span className="text-muted-foreground font-medium">{label}</span>
      <span className="flex items-center gap-2">
        <span className="text-foreground font-semibold tabular-nums">{primary}</span>
        {lift ? <ExperimentLiftBadge value={lift} /> : null}
      </span>
    </div>
  );
}
